import React from "react";
import bannerImage from "../../Images/Banner/Advisor.webp";
import procedureImg from "../../Images/gov-body/meeting.webp"; // adjust if needed
import icon1 from "../../Images/placement/icon (1).webp";
import icon2 from "../../Images/placement/icon (2).webp";
import icon3 from "../../Images/placement/icon (3).webp";
import icon4 from "../../Images/placement/icon (4).webp";
import icon5 from "../../Images/placement/icon (5).webp";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";

const procedures = [
    {
        id: 1,
        title: "Governing Body",
        icon: icon1,
        img: procedureImg,
        url: "governing-body"
    },
    {
        id: 2,
        title: "Board of Management",
        icon: icon2,
        img: procedureImg,
        url: "board-management"
    },
    {
        id: 3,
        title: "Academic Council",
        icon: icon3,
        img: procedureImg,
        url: "academic-council"
    },
    {
        id: 4,
        title: "Other Committees",
        icon: icon5,
        img: procedureImg,
        url: "other-communitie"
    },
];

const Management = () => {
    return (
        <>
            <title>University Administration | ISBM University Profiles</title>
            <meta
                name="description"
                content="Understand ISBM University’s administration: who leads, how governance works & how policies are implemented for efficient, quality education."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>dynamic and visionary management team</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Management
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50">
                <div className="container-xxl">
                    <div className="row g-40 align-items-center flex-wrap-reverse">
                        <div className="col-lg-5">
                            <div className="rts-right-section rt-relative">
                                <div className="campus-video">
                                    <img
                                        src={bannerImage}
                                        alt="Empty Conference Room With Sunlight Through Large Windows"
                                        className="img-fluid rounded-5 shadow"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-1"></div>
                        <div className="col-lg-6">
                            <div>
                                <h2 className="modern-title text-blue">
                                    Management
                                </h2>
                                <div className="underline-divider"></div>
                                <p>
                                    At the core of ISBM University’s success lies a dynamic and visionary
                                    management team that ensures the institution stays aligned with its mission of
                                    providing quality education, industry relevance, and holistic development.
                                    The <b>Governing Body</b> is the highest decision-making authority, responsible for
                                    shaping long-term strategies, policies, and goals. Comprising eminent academicians,
                                    senior professionals, and educationists, this body works relentlessly to maintain academic
                                    excellence and administrative transparency.
                                </p>
                                <p>
                                    The <b>Board of Management</b> plays a vital role in implementing the university’s academic,
                                    operational, and financial decisions. It bridges the gap between vision and execution,
                                    ensuring all departments and programs work in sync with regulatory standards and emerging
                                    global trends. Their efforts focus on offering a student-centric learning environment, upholding
                                    institutional values, and constantly innovating across academic offerings.
                                </p>
                                <p>
                                    The <b>Board of Advisors</b> and Other Committees bring together experts from academia, research,
                                    industry, and public service to guide and mentor the university in niche areas.
                                    These committees ensure quality assurance, curriculum development, ethics, student
                                    welfare, grievance redressal, and inclusive growth. Their collective expertise ensures
                                    that students not only receive knowledge but are also equipped with the skills and support
                                    they need to thrive in their careers and life beyond the classroom.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section >


            <section className="ptb-50 color-section">
                <div className="container-xxl">
                    <div className="row justify-content-sm-center">
                        <div className="col-lg-12 col-sm-11">
                            <div className="rts-section mb-4 row">
                                <h2 className="modern-title section-title text-center text-blue">Our Management</h2>
                                <p className="fs-5">
                                    At the core of ISBM University’s success lies a dynamic and visionary
                                    management team that ensures the institution stays aligned with its mission
                                    of providing quality education.
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-sm-center justify-content-md-start g-5">
                        {procedures.map((procedure) => (
                            <div
                                className="col-lg-4 col-md-6 col-sm-11"
                                key={procedure.id}
                            >
                                <div className="single-procedure">
                                    <div className="procedure-image">
                                        <img
                                            src={procedure.img}
                                            alt="application-thumb"
                                            className="img-fluid"
                                        />
                                    </div>
                                    <a href={`/${procedure.url}`} target="_blank" className="h5 d-block mb-3 text-white">
                                        {procedure.title}
                                    </a>
                                    <div className="row">
                                        <div className="col-6">
                                            <img className="procedure-icon" src={procedure.icon} alt="step-icon" />
                                        </div>
                                        <div className="col-6 d-flex flex-column justify-content-end">
                                            <a href={`/${procedure.url}`} target="_blank" className="procedure-button mt-auto">Read More<i className="ti ti-arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Management;
